<template>
  <span v-if="isHeader">
    <!--  -->
    Actions
  </span>
  <div v-else>
    <dropdown v-if="$route.meta.isAdmin">
      <dropdown-action icon="edit" @click="onClickEdit"
        >Edit {{ type }}</dropdown-action
      >
      <dropdown-action
        icon="tick"
        @click="onClickActivate"
        v-if="rowData.status == 'inactive'"
        >Activate {{ type }}</dropdown-action
      >
      <dropdown-action
        icon="tick"
        @click="onClickDeactivate"
        v-if="rowData.status !== 'inactive'"
        >Deactivate {{ type }}</dropdown-action
      >
      <dropdown-action icon="delete" @click="onClickDelete"
        >Delete {{ type }}</dropdown-action
      >
    </dropdown>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown'
import DropdownAction from '@/components/DropdownAction'

import TrAction from '@/components/TableRowAction'

import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import UserHasPermission from '@/mixins/UserHasPermission'
export default {
  name: 'document-actions',

  props: {
    rowData: Object,
    id: [String, Number],
    routePath: String,
    type: {
      type: String,
      default: 'Article'
    },
    previewRoute: {
      type: String,
      default: 'AdminDocumentPreview'
    },
    deleteAction: {
      type: String,
      default: 'News/delete'
    },
    publishAction: {
      type: String,
      default: 'News/approve'
    },
    rejectAction: {
      type: String,
      default: 'News/reject'
    }
  },

  computed: {
    userCanAdd() {
      return this.userHasPermission('add_edit_news')
    },
    userCanPublish() {
      return this.userHasPermission('publish_news')
    }
  },

  methods: {
    onClickEdit() {
      this.$router.push({
        name: this.routePath,
        params: { id: this.id }
      })
    },

    onClickActivate() {
      this.$store.dispatch('Banner/setStatusSlider', {
        status: 'active',
        id: this.id
      }).then(() => {
        this.$emit('tableUpdate')
      })
    },

    onClickDeactivate() {
      this.$store.dispatch('Banner/setStatusSlider', {
        status: 'inactive',
        id: this.id
      }).then(() => {
        this.$emit('tableUpdate')
      })
    },

    onClickDelete() {
      this.$store.dispatch('createDialog', {
        confirm: () => {
          this.$store.dispatch(this.deleteAction, this.id).then(() => {
            this.$emit('tableUpdate')
          })
        }
      })
    }
  },

  data() {
    return {
      rejectionReason: '',
      rejectModalOpen: false
    }
  },

  components: {
    Dropdown,
    DropdownAction,
    TrAction
  },

  mixins: [VuetableFieldMixin, UserHasPermission]
}
</script>
